module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      component: true, disabled: _vm.loading
    }
  }, [(_vm.isNew) ? _c('h1', [_vm._v("Skapa lösenord")]) : _c('h1', [_vm._v("Glömt lösenord")]), _vm._v(" "), (!_vm.loggedIn) ? _c('div', [(_vm.isNew) ? _c('p', [_vm._v("Ange din e-postadress nedan för att få instruktioner om hur du skapar ditt lösenord.")]) : _c('p', [_vm._v("Ange din e-postadress nedan för att få instruktioner om hur du återställer ditt lösenord.")]), _vm._v(" "), _c('Loading', {
    attrs: {
      "show": _vm.loading
    }
  }), _vm._v(" "), _c('div', [_c('label', [_vm._v("E-postadress")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.email),
      expression: "user.email"
    }],
    attrs: {
      "placeholder": "Din e-postadress",
      "type": "email"
    },
    domProps: {
      "value": (_vm.user.email)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.save()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "email", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "center wide"
  }, [(_vm.errorMessage) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errorMessage)), _c('br'), _c('br'), _vm._v("Ring gästservice på "), _c('a', {
    attrs: {
      "href": "tel:054-13 26 00"
    }
  }, [_vm._v("054-13 26 00")]), _vm._v(" om du behöver hjälp."), _c('br'), _c('br')]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "center wide"
  }, [_c('button', {
    staticClass: "block",
    on: {
      "click": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("Begär nytt lösenord")])])], 1) : _vm._e(), _vm._v(" "), (_vm.loggedIn) ? _c('div', [_c('p', [_vm._v("Du är redan inloggad. "), _c('router-link', {
    attrs: {
      "to": "{name: 'my pages'}"
    }
  }, [_vm._v("Klicka här")]), _vm._v(" om du vill gå till dina sidor.")], 1)]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fefdd436"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pages/RequestResetPassword.vue
// module id = 1063
// module chunks = 0